<template>
    <div>
        <div v-if="claims.auxiliaryRegister.read" class="auxiliaryRegisterContainer">
            <div class="loader mt-5" v-if="loading"></div>
            <div v-show="!loading && register">
                <div v-if="register">
                    <panel v-for="(panel, index) in register.panels" :panel="panel" :key="'register' + index"
                           ></panel> <!-- @deleteSavedFile="deleteSavedFile" -->
                </div>
            </div>
        </div>
        <div v-else class="mt-3">
            <div class="text-danger radio-message-danger mt-2">
                <i class="fa fa-exclamation-circle mr-2"></i>
                {{ $t('auxiliary.notAuthorized')}}
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Panel from '../dynamic/Panel';
import { DynamicRegisterModel, EditorRegister } from '@/models/models';
import {
    ComponentType,
    Culture,
} from '@/models/enums';
import CustomTabs from '../../components/tab/CustomTabs';
import DynamicFieldChangeHandler from '@/services/dynamicFieldChangeHandler.service';
import { mapGetters } from 'vuex';

Vue.use(CustomTabs);

export default {
    inject: ['$validator'],
    props: {
        registerId: {
            type: [Number, String],
            required: true
        },
        entryId: {
            type: [Number, String]
        },
        registerName: {
            type: String,
            default: ''
        }
    },
    components: {
        Panel
    },
    data() {
        return {
            register: null,
            loading: false,
            // files: [],
            // people: [],
            // addresses: [],
            window: {
                width: 0,
                height: 0
            },
            // savedFilesToDelete: [],
            pageLoaded: false,
            isSaved: false,
            areObjectsEqual: false
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        this.$store.dispatch('clearCurrentRegisterData', this.register);
    },
    methods: {
        dynamicFieldChangeHandler(newValue, oldValue, model) {
            DynamicFieldChangeHandler.onChangeHandler(newValue, oldValue, model, this.register);
        },
/*        deleteSavedFile(fileId) {
            this.savedFilesToDelete.push(fileId);
        }, */
        loadEmptyRegisterStructure() {
            if (!this.claims.auxiliaryRegister.read) {
                return;
            }

            this.loading = true;
            this.$http
                .get(`/api/AuxiliaryRegisters/${this.registerId}/structure`)
                .then(result => {
                    this.register = new EditorRegister(result.data);
                    this.$store.initialModel = _.cloneDeep(this.register);
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                }).then(() => {
                this.$store.dispatch('setCurrentRegisterData', this.register);
            });
        },
        loadRegisterStructureWithEntities() {
            if (!this.claims.auxiliaryRegister.read) {
                return;
            }

            this.loading = true;
            const entryId = this.entryId;

            this.$http
                .get(`/api/AuxiliaryRegisters/${this.registerId}/values/${entryId}`)
                .then(result => {
                    this.register = new EditorRegister(result.data);
                    this.$store.initialModel = _.cloneDeep(this.register);
                    this.loading = false;

                })
                .catch(error => {
                    this.loading = false;

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                }).then(() => {
                this.$store.dispatch('setCurrentRegisterData', this.register);
            });
        },
        getDynamicRegisterModelForSubmit() {
            if (!this.register || !this.register.panels) {
                return;
            }

            this.loading = true;
            this.files = [];
            let fieldsValues = [];

            this.register.panels.forEach(panel => {
                panel.components.forEach(component => {
                    component.fieldValue.registerEntryId = this.entryId;
                    component.fieldValue.id = component.fieldValue.id;
                    component.fieldValue.registerFieldId = component.id;
                    component.fieldValue.fieldType = component.fieldType;
                    component.fieldValue.numberType = component.numberType;
                    component.fieldValue.label = component.label;
                    component.fieldValue.labelEn = component.labelEn;
                    component.fieldValue.name = component.name;
                    component.fieldValue.nameEn = component.nameEn;
                    component.fieldValue.isMultiDropdown = component.isMultiDropdown;
                    if (component.isMultiDropdown) {
                        component.fieldValue.intValue = '';
                    }
                    fieldsValues.push(component.fieldValue);
                    if (component.fieldType === ComponentType.FileUpload) {
                        component.fieldValue.files.forEach(file => {
                            this.files.push(file);
                        });
                    }
                });
            });

            const dynamicRegisterModel = new DynamicRegisterModel({
                fieldValues: fieldsValues,
                // people: this.people,
                // addresses: this.addresses,
                registerName: this.registerName,
                registerEntityExtension: this.register.registerEntityExtension,
                // savedFilesToDeleteIds: this.savedFilesToDelete
            });

            return dynamicRegisterModel;
        },
/*        uploadFiles(registerEntityId, dataToMap) {
            if (this.isNew) {
                this.files = [];
                this.register.panels.forEach(panel => {
                    panel.components.forEach(component => {
                        if (component.fieldType === ComponentType.FileUpload) {
                            component.fieldValue.files.forEach(file => {
                                this.files.push(file);
                            });
                        }
                    });
                });

                if (this.isNew) {
                    this.mapIdsToFiles(dataToMap);
                }
            }
            let formData = new FormData();

            const descriptionsJson = this.getFilesDescriptionsJson();
            this.files.forEach(file => {
                formData.append('files', file.content, file.fileName);
            });
            formData.append('descriptionJson', descriptionsJson);

            this.$http
                .post('/api/DynamicRegisters/UploadFiles', formData)
                .then(result => {
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successUploadingFiles'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    });

                    if (this.isNew && registerEntityId > 0) {
                        this.$router.push(`/registers/events/edit/${registerEntityId}`);
                    } else {
                        this.$router.go();
                    }
                })
                .catch(error => {
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorUploadingFiles'),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });

                    if (registerEntityId > 0) {
                        this.$router.push(`/registers/events/edit/${registerEntityId}`);
                    }
                });
        },
        mapIdsToFiles(ids) {
            this.files.forEach(file => {
                const uid = file.uid;
                const id = ids.resultList.findIndex(x => x.uid === uid);
                if (id) {
                    file.registerEntityFieldValueId = ids.resultList[id].id;
                }
            });
        },
        getFilesDescriptionsJson() {
            let descriptions = [];
            let fileIndex = 0;
            this.files.forEach(file => {
                fileIndex++;
                file.fileName = `${fileIndex}_${file.fileName}`;
                descriptions.push({
                    fileName: file.fileName,
                    description: `${fileIndex}_${file.fileDescription}`,
                    length: file.content.size,
                    registerEntityFieldValueId: file.registerEntityFieldValueId
                });
            });

            return JSON.stringify(descriptions);
        } */
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },
    mounted() {
        this.pageLoaded = true;

        if (this.isNew) {
            this.loadEmptyRegisterStructure();
        } else {
            this.loadRegisterStructureWithEntities();
        }
    },
    watch: {
/*        'register': {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                this.areObjectsEqual = _.isEqual(newVal, this.$store.initialModel);
            }
        } */
    },
    computed: {
        ...mapGetters(['claims']),
        isNew() {
            return this.entryId === undefined || isNaN(this.entryId) || this.entryId <= 0;
        },
        isBgCulture() {
            return this.$store.getters.currentCulture === Culture.BG;
        }
    }
};
</script>

<style lang="scss" scoped>
.auxiliaryRegisterContainer {
    margin: 48px -15px 0 -15px;
}

.nav-tabs .nav-link.active {
    color: #009688;
    border-bottom: 1px solid #009688;
}

.nav-tabs .nav-link {
    color: #212529;
    border-bottom: 1px solid lightgrey;
    transition: border-color 1s;

    &:hover {
        text-decoration: none;
        color: #009688;
    }
}
</style>
